import { useEffect } from 'react';
import { useFramework } from '@/framework';
import type { MouseOperate } from '@/plugins/mouse-operate';
import type { Displacement } from './displacement';
import { bindMouseOperateDisplacement } from './mouse-operate-controller';

/**
 * 将 MouseOperate 的基础操作结果映射为光标提示。
 *
 * 这里只消费事件中的数值，不依赖实际 layer，因此基础更新完成后即使 layer 被替换或移除，
 * resize/scale/rotate/move 的提示与清理边界仍保持稳定。
 */
export const useMouseOperateDisplacement = (displacement: Displacement) => {
    const framework = useFramework();

    useEffect(() => {
        const mouseOperate = framework.service.registration.getInstance<MouseOperate>('MouseOperate');
        if (!mouseOperate) return;

        return bindMouseOperateDisplacement(mouseOperate, displacement);
    }, [displacement, framework]);
};
